
const v1 = resolve => require(['./v1.vue'], resolve);

export default {
  v1
}
